import React, { useState } from "react";
import PropTypes from "prop-types";
import RowAlert from "../../misc/RowAlert";
import AjaxTableDisplay from "../../misc/AjaxTableDisplay";
import { useDispatch, useSelector } from "react-redux";
import { hideModal } from "../../../actions/actionCreators";
import withModal from "../withModal";
import MaterialModal from "../MaterialModal";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import h from "../../../helpers";

const FlowWaterfallModal = ({ modalProps, isOpen }) => {
    const dispatch = useDispatch();
    const [isPrimaryButtonDisabled, setIsPrimaryButtonDisabled] = useState(false);
    const enabledFeatures = useSelector(state => state.session.enabledFeatures || []);
    const simpleRespond = enabledFeatures.includes("waterfall-simple-respond");
    const [isEmailsValid, setIsEmailsValid] = useState(true);
    const [contactEmail, setContactEmail] = useState("");
    const [error, setError] = useState(false);

    const { flowId } = modalProps;

    const hide = () => dispatch(hideModal("FLOW_WATERFALL"));

    const getEmailOpt = () => {
        let content;
        content = (
            <div className="flow-edit-body">
                {simpleRespond && (
                    <Paper>
                        <div style={{ marginLeft: "20px", paddingBottom: "20px", fontSize: "16px" }}>
                            Set email address to receive a report.
                        </div>
                        <TextField
                            id="flow-control-custom-emails"
                            error={!isEmailsValid}
                            label="Emails"
                            type="text"
                            onChange={e => handleSettingValue(e.target.value)}
                            value={contactEmail}
                            helperText={
                                `${!isEmailsValid ? "Email(s) are invalid. " : ""}` +
                                "We will send email(s) with attachment. You can add multiple emails seperated by a semicolon."
                            }
                            style={{ width: "90%", marginLeft: "20px" }}
                        />
                    </Paper>
                )}
            </div>
        );

        return content;
    };

    function isValidateEmailsFunc(string) {
        if (string == undefined || !string.trim()) {
            return false;
        }

        const regex = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
        const result = string.replace(/\s/g, "").split(/,|;/);
        for (let i = 0; i < result.length; i++) {
            if (!regex.test(result[i])) {
                return false;
            }
        }

        return true;
    }

    const handleSettingValue = val => {
        setIsEmailsValid(isValidateEmailsFunc(val));
        setContactEmail(val);
    };

    const renderInner = flowId =>
        flowId ? (
            <AjaxTableDisplay
                countUrl={"/FlowWaterfallReport/Count/" + flowId}
                dataUrl={"/FlowWaterfallReport/Data/" + flowId}
                header={null}
                belowErrorMessage={null}
                showRecordCount
                onPrimaryButtonDisabledFunc={handlePrimaryButtonDisabled}
            />
        ) : (
            <RowAlert type="danger">Unknown flow.</RowAlert>
        );

    const downloadReport = () => (window.location = "/FlowWaterfallReport/ExportXLSX/" + flowId || 0);

    const onPrimaryButtonRequest = () => {
        hide();
        downloadReport();
    };

    const onSecondaryButtonRequest = () => {
        if (simpleRespond) {
            if (isValidateEmailsFunc(contactEmail)) {
                setIsEmailsValid(true);
                const saveUrl =
                    "/FlowWaterfallReport/SendReportToEmail?" +
                    h.serialize({
                        emailList: contactEmail,
                        flowId,
                    });

                return fetch(saveUrl, { method: "POST", credentials: "same-origin" })
                    .then(h.checkStatus)
                    .then(h.toJson)
                    .then(() => {
                        setIsEmailsValid(false);
                        setTimeout(() => {
                            setIsEmailsValid(true);
                        }, 3000);
                        hide();
                    })
                    .catch(error => {
                        h.error("Error sending waterfall report to email", error);
                        setError(true);
                    });
            } else {
                setIsEmailsValid(false);
                h.error("Type in valid email!!!", error);
                setError(true);
            }
        }
    };

    const handlePrimaryButtonDisabled = () => {
        setIsPrimaryButtonDisabled(true);
    };

    return (
        <MaterialModal
            title="Waterfall Report"
            isOpen={isOpen}
            onClose={hide}
            id="waterfall-report"
            maxWidth="md"
            fullWidth
            onPrimaryButtonRequest={onPrimaryButtonRequest}
            primaryButtonText={"Download"}
            isPrimaryButtonDisabled={isPrimaryButtonDisabled}
            onSecondaryButtonRequest={onSecondaryButtonRequest}
            secondaryButtonText={"Email"}
            isSecondaryButtonDisabled={simpleRespond ? !isEmailsValid : true}
            showSecondaryButton={simpleRespond ? true : false}
        >
            {simpleRespond && getEmailOpt()}
            {renderInner(flowId || 0)}
        </MaterialModal>
    );
};

FlowWaterfallModal.propTypes = {
    // Injected from Redux
    modalProps: PropTypes.object,
    isOpen: PropTypes.bool,
    // Injected from Redux (ActionCreators)
    hideModal: PropTypes.func,
};

export default withModal(FlowWaterfallModal, "FLOW_WATERFALL");
